<template>
    <CommonBox title="Create Learning System Account" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-position="top" :model="form" :rules="rules">
            <el-form-item label="Email of learning system:" prop="Email">
                <el-input v-model="form.Email"></el-input>
            </el-form-item> 

            <el-form-item label="Password of learning system:" prop="Password">
                <el-input v-model="form.Password" type="password" autocomplete="new-password"></el-input>
            </el-form-item> 
        </el-form>
    </CommonBox>
</template>
<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    data () {
        return {
            form:{
                Email:"",
                Password:"",
                Type:'learning'
            },
            rules:{
                Email:[{ required: true, message: 'Please input the email address', trigger: 'blur' }],
                Password:[{required: true, message: 'Please enter a password', trigger: 'blur'}, 
                    { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/, 
                        message: 'The password must be at least 11 characters long and contain at least three of the four types: uppercase letters, lowercase letters, special characters and digits.' }]
            }
        };
    },
    created () {
        this.$http.get("getAccountInfo",{},(data)=>{
            this.form.Email = data.data.Email;
        });
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                this.$http.post('newUserOtherSys',this.form,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
    
</style>